/**
 * International Morse code lookup. Used by the RACON renderer to paint
 * the Morse character of a radar beacon as a radial trail of
 * dots/dashes extending outward from the beacon along the bearing from
 * own ship — the iconic on-screen feature that lets a navigator
 * identify a RACON at range without reading a label.
 */
const MORSE: Record<string, string> = {
  A: ".-",
  B: "-...",
  C: "-.-.",
  D: "-..",
  E: ".",
  F: "..-.",
  G: "--.",
  H: "....",
  I: "..",
  J: ".---",
  K: "-.-",
  L: ".-..",
  M: "--",
  N: "-.",
  O: "---",
  P: ".--.",
  Q: "--.-",
  R: ".-.",
  S: "...",
  T: "-",
  U: "..-",
  V: "...-",
  W: ".--",
  X: "-..-",
  Y: "-.--",
  Z: "--..",
  "0": "-----",
  "1": ".----",
  "2": "..---",
  "3": "...--",
  "4": "....-",
  "5": ".....",
  "6": "-....",
  "7": "--...",
  "8": "---..",
  "9": "----.",
};

/**
 * Look up the Morse string for a single character. Returns undefined if
 * the character isn't covered (the renderer falls back to a label).
 */
export function morseFor(char: string): string | undefined {
  return MORSE[char.toUpperCase()];
}
